import React, { useState, Fragment } from "react";
import { Col, Row, Container } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import BusList from "./BusList";
import BusView from "./BusView";
import AddBusType from "./addBusType";
import AddAmenities from "./addAmenities";
import BusViewPropertyList from "./BusViewPropertyList";
import SetPrice from "./setPrice";
import AddBusGeneralView from "./addBusGeneralView";
import SeatManagement from "./SeatManagement";

const BusVendor = (props) => {
  const [active, updateActive] = useState("1");
  const [data, setdata] = useState({});
  const items = [
    { id: "1", type: "Add Bus" },
    { id: "2", type: "Bus List" },
    { id: "5", type: "Bus Management" },
    { id: "9", type: "Seat Management" },
    { id: "3", type: "Add Bus Amenities & Facilities" },
  ];

  return (
    <Fragment>
      <Container fluid style={{ paddingLeft: "10px" }}>
        <Row>
          <Col lg={2} md={12} className={classes.Response2}>
            <div style={{ height: "100%" }}>
              <ul className={classes.Ul}>
                {items.map((item) => (
                  <li
                    key={item.id}
                    onClick={() => updateActive(item.id)}
                    className={classes.Li}
                    style={{
                      backgroundColor: `${
                        active === item.id ? "steelblue" : "#585858"
                      }`,
                      textAlign: "center",
                    }}
                  >
                    {item.type}
                  </li>
                ))}
                {active === "4" ? (
                  <li
                    onClick={() => updateActive("2")}
                    className={classes.Li}
                    style={{
                      backgroundColor: `${
                        active === "4" ? "steelblue" : "#585858"
                      }`,
                      textAlign: "center",
                    }}
                  >
                    Back
                  </li>
                ) : null}
              </ul>
            </div>
          </Col>
          <Col lg={10} md={12} className={classes.Response}>
            <div style={{ height: "100%" }}>
              {active === "1" ? (
                <AddBusType />
              ) : active === "2" ? (
                <BusList
                  click={() => updateActive("4")}
                  mydata={(e) => setdata(e)}
                />
              ) : active === "3" ? (
                <AddAmenities />
              ) : active === "5" ? (
                <SetPrice />
              ) : active === "9" ? (
                <SeatManagement />
              ) : active === "4" ? (
                <AddBusGeneralView
                  click={() => updateActive("2")}
                  data={data}
                />
              ) : null}
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default BusVendor;
